// import React, { useEffect, useState, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Header from '../../layouts/Header';
// import { 
//   ArrowLeft, 
//   BarChart, 
//   People, 
//   Cart, 
//   Person, 
//   PieChart, 
//   Tag, 
//   Calendar, 
//   CurrencyDollar, 
//   Box, 
//   ListUl, 
//   Clipboard, 
//   Shop,
//   Box2,
//   CartX,
//   Bank,
//   Archive,
//   CartCheck,
//   FileText,
//   Download,
//   X,
//   FileEarmarkSpreadsheet,
//   Search,
//   Grid,
//   Layers,
//   GraphUp,
//   Ticket,
//   BoxSeam,
//   CashStack,
//   Receipt
// } from 'react-bootstrap-icons';
// import { useSelector } from 'react-redux';
// import { Modal, Button, Form, Row, Col, DropdownButton, Dropdown, Spinner, InputGroup } from 'react-bootstrap';
// import { toast } from 'react-toastify';
// import DatePicker from 'react-datepicker';
// import Select from 'react-select';
// import axiosInstance from '../../api/axios';// import makeAnimated from "react-select/animated";
// import OutletSelect from '../../components/OutletSelect';
// import { MAX_DATE_RANGE_DAYS, DATE_RANGE_ERROR_MESSAGE } from '../../constants/dateConstants';
// import { ShoppingCart, TrendingUp } from 'lucide-react';

// const AllReports = () => {

//     const currentSkin = localStorage.getItem("skin-mode") ? "dark" : ""; 
//     const [skin, setSkin] = useState(currentSkin);
//     const accessToken = localStorage.getItem("accessToken");
//     const animatedComponents = makeAnimated();

//     const navigate = useNavigate();
//     const [selectedReport, setSelectedReport] = useState(null);
//     const [selectedTransaction, setSelectedTransaction] = useState(null);
//     const { access } = useSelector((state) => state.login);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [activeGroup, setActiveGroup] = useState('all');

//     // State for Product Addon Report Modal
//     const [showProductAddonModal, setShowProductAddonModal] = useState(false);
//     const [outlets, setOutlets] = useState([]);

//     // Filters States
//     const [selectedOutlet, setSelectedOutlet] = useState('');
//     const [selectedOutletName, setSelectedOutletName] = useState('');
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const [categoryList, setCategoryList] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState('');
//     const [selectedCategoryName, setselectedCategoryName] = useState('');
//     const [productsList, setProductsList] = useState([]);
//     const [productId, setProductId] = useState('');
//     const [filteredProducts, setFilteredProducts] = useState([]);
//     const [addonGroup, setAddonGroup] = useState([]);
//     const [addons, setAddons] = useState([]);
//     const [filteredAddonValues, setFilteredAddonValues] = useState([]);
//     const [selectedAddonValue, setSelectedAddonValue] = useState([]);

//     const [downloading, setDownloading] = useState(false);
//     const [error, setError] = useState('');

//     const customStyles = {
//         control: (provided, state) => ({
//             ...provided,
//             width: "100%",
//             borderRadius: "6px",
//             borderColor: state.isFocused ? "#80bdff" : "#ced4da",
//             boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
//             "&:hover": {
//                 borderColor: state.isFocused ? "#80bdff" : "#ced4da",
//             },
//         }),
//         placeholder: (provided) => ({
//             ...provided,
//             color: "#6c757d",
//         }),
//     };

//     // Define report groups
//     const reportGroups = {
//         sales: {
//             name: "Order & Sales",
//             icon: <Cart size={18} />,
//             color: "#1cc88a",
//             reports: [
//                 { path: "/reports/order-reports", name: "Order Report", icon: <Cart size={20} />, color: "#1cc88a", accessKey: "OrdersReport:get", description: "View all order details" },
//                 // { path: "/reports/online-sales-report", name: "Online Sales Report", icon: <TrendingUp size={20} />, color: "#4e73df", accessKey: "OnlineSalesReport:get", description: "Zomato and Swiggy sales analysis" },
//                 { path: "/reports/product-sales-report", name: "Product Sales Report", icon: <CurrencyDollar size={20} />, color: "#4e73df", accessKey: "ProductSalesReport:get", description: "Product wise sales analysis" },
//                 { path: "/reports/item-wise-report", name: "Item Wise Report", icon: <ListUl size={20} />, color: "#36b9cc", accessKey: "ItemWiseReport:get", description: "Item wise sales breakdown" },
//                 { path: "/reports/addon-sales-report", name: "Addon Sales Report", icon: <Clipboard size={20} />, color: "#e74a3b", accessKey: "AddonSalesReport:get", description: "Addon sales analytics" },
//                 { 
//                     path: "#", 
//                     name: "Product + Addon Report", 
//                     icon: <FileText size={20} />, 
//                     color: "#9b59b6", 
//                     accessKey: "ProductAddonSales:get",
//                     description: "Combined product and addon sales",
//                     isModal: true,
//                     modalType: "productAddon"
//                 },
//             ]
//         },
//         customers: {
//             name: "Customer & User",
//             icon: <People size={18} />,
//             color: "#36b9cc",
//             reports: [
//                 { path: "/reports/customer-reports", name: "Customer Report", icon: <People size={20} />, color: "#4e73df", accessKey: "CustomerReport:get", description: "Customer data and analytics" },
//                 { path: "/reports/kiosk-user-reports", name: "Kiosk User Report", icon: <Person size={20} />, color: "#36b9cc", accessKey: "KioskUserReport:get", description: "Kiosk user statistics" },
//                 { path: "/reports/user-analytics-reports", name: "User Analytics Report", icon: <PieChart size={20} />, color: "#f6c23e", accessKey: "UserAnalyticsReport:get", description: "User behavior analytics" },
//             ]
//         },
//         coupons: {
//             name: "Coupons & Promotions",
//             icon: <Tag size={18} />,
//             color: "#e74a3b",
//             reports: [
//                 { path: "/reports/coupons-report", name: "Coupons Report", icon: <Tag size={20} />, color: "#e74a3b", accessKey: "CouponsReport:get", description: "Coupon usage and performance" },
//                 { path: "/reports/journey-coupon-report", name: "Journey Coupon Report", icon: <Tag size={20} />, color: "#e74a3b", accessKey: "JourneyCouponReport:get", description: "Journey based coupon analytics" },
//                 { path: "/reports/user-coupon-report", name: "User Coupon Report", icon: <Tag size={20} />, color: "#1cc88a", accessKey: "UserCouponReport:get", description: "User wise coupon usage" },
//                 { path: "/reports/journey-revenue-report", name: "Journey Revenue Report", icon: <CurrencyDollar size={20} />, color: "#f6c23e", accessKey: "JourneyCouponRevenueReport:get", description: "Revenue from journeys" },
//             ]
//         },
//         summary: {
//             name: "Summary & Analytics",
//             icon: <BarChart size={18} />,
//             color: "#f6c23e",
//             reports: [
//                 { path: "/reports/day-summary-report", name: "Day Summary", icon: <Calendar size={20} />, color: "#5a5c69", accessKey: "DaySummaryReport:get", description: "Daily business summary" },
//                 { path: "/reports/month-summary-report", name: "Month Summary", icon: <Calendar size={20} />, color: "#858796", accessKey: "MonthSummaryReport:get", description: "Monthly business summary" },
//             ]
//         },
//         inventory: {
//             name: "Inventory & Stock",
//             icon: <Box size={18} />,
//             color: "#4e73df",
//             reports: [
//                 { path: "/reports/outlet-stock-report", name: "Outlet Stock Report", icon: <Shop size={20} />, color: "#e74a3b", accessKey: "OutletStockReport:get", description: "Current outlet stock levels" },
//                 { path: "/reports/outlet-inventory-report", name: "Outlet Inventory Report", icon: <Shop size={20} />, color: "#1cc88a", accessKey: "OutletInventoryReport:get", description: "Outlet inventory details" },
//                 { path: "/reports/storage-location-stock-report", name: "Storage Location Stock", icon: <Box2 size={20} />, color: "#e74a3b", accessKey: "StorageLocationStockReport:get", description: "Storage wise stock status" },
//                 { path: "/reports/stock-consumption-report", name: "Stock Consumption", icon: <Calendar size={20} />, color: "#858796", accessKey: "StockConsumptionReport:get", description: "Stock consumption patterns" },
//                 { path: "/reports/rm-reorder-report", name: "RM Reorder Level", icon: <Box size={20} />, color: "#f6c23e", accessKey: "RMReorderReport:get", description: "Reorder level monitoring" },
//                 { path: "/reports/out-of-stock-product-report", name: "Out of Stock Report", icon: <CartX size={20} />, color: "#e74a3b", accessKey: "ProductOutofStockReport:get", description: "Out of stock products" },
//                 { path: "/reports/rm-stock-report", name: "RM Central Stock", icon: <Archive size={20} />, color: "#e74a3b", accessKey: "RMCentralStockReport:get", description: "Central stock status" },
//             ]
//         },
//         subscription: {
//             name: "Subscription",
//             icon: <CartCheck size={18} />,
//             color: "#9b59b6",
//             reports: [
//                 { path: "/subscription/subscription-users", name: "Subscription Purchase", icon: <CartCheck size={20} />, color: "#1cc88a", accessKey: "SubscriptionPurchaseReport:get", description: "Subscription purchases" },
//                 { path: "/subscription/subscription-consumption-report", name: "Subscription Consumption", icon: <BarChart size={20} />, color: "#5a5c69", accessKey: "SubscriptionConsumptionReport:get", description: "Subscription usage" },
//             ]
//         }
//     };

//     const transactions = [
//         { path: "/transaction/central-stock-report", name: "Central Stock Transactions", icon: <Bank size={20} />, color: "#e74a3b", accessKey: "CentralStockTransaction:get", description: "Central stock movements" },
//         { path: "/transaction/outlet-stock-report", name: "Outlet Stock Transactions", icon: <Archive size={20} />, color: "#e74a3b", accessKey: "OutletStockTransaction:get", description: "Outlet stock movements" }
//     ];

//     // Filter reports based on user access and search term
//     const getFilteredReportsForGroup = (groupReports) => {
//         let filtered = access === null || access?.length === 0 || access === undefined
//             ? groupReports 
//             : groupReports.filter(report => access?.includes(report?.accessKey));

//         if (searchTerm) {
//             filtered = filtered.filter(report => 
//                 report.name.toLowerCase().includes(searchTerm.toLowerCase())
//             );
//         }

//         return filtered;
//     };

//     const filteredTransactions = access === null || access?.length === 0 || access === undefined
//         ? transactions
//         : transactions.filter(tran => access?.includes(tran?.accessKey));

//     // Get total count of filtered reports
//     const totalFilteredReports = useMemo(() => {
//         let total = 0;
//         Object.keys(reportGroups).forEach(groupKey => {
//             total += getFilteredReportsForGroup(reportGroups[groupKey].reports).length;
//         });
//         return total;
//     }, [searchTerm, access]);

//     const handleReportClick = (report) => {
//         if (report.isModal && report.modalType === "productAddon") {
//             setShowProductAddonModal(true);
//         } else {
//             setSelectedReport(report);
//             navigate(report.path);
//         }
//     };

//     const handleTransactionClick = (transaction) => {
//         setSelectedTransaction(transaction);
//         navigate(transaction.path);
//     };

//     const handleBackClick = () => {
//         setSelectedReport(null);
//         setSelectedTransaction(null);
//         navigate("/reports/all-reports");
//     };

//     const handleCloseModal = () => {
//         setShowProductAddonModal(false);
//         setSelectedOutlet('');
//     };

//     const handleAddonValueChange = (e) => {
//         setSelectedAddonValue(e);
//     }

//     const getOutlets = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("outlet", { headers });
//             if (response?.data?.status === true) {
//                 const activeOutlets = response?.data?.data?.outlets.filter((active) => active?.status === "ACTIVE" || "INACTIVE");
//                 setOutlets(activeOutlets);
//             }
//         } catch (error) {
//             console.error("Error fetching outlets:", error);
//         }
//     };

//     const getCategoryList = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("masters/category/get", { headers });
//             if (response?.data?.status === true) {
//                 setCategoryList(response?.data?.data?.categories || []);
//             }
//         } catch (error) {
//             console.error("Error fetching categories:", error);
//         }
//     };

//     const getProductsList = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("product", { headers });
//             if (response?.data?.status === true) {
//                 setProductsList(response?.data?.data?.products || []);
//                 setFilteredProducts(response?.data?.data?.products || []);
//             }
//         } catch (error) {
//             console.error("Error fetching products:", error);
//         }
//     };

//     const getAddons = async() => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("addons?page=1&limit=1000", { headers });
//             setAddons(response?.data?.data?.addons);
//         } catch (error) {
//             console.error("Error fetching addons:", error);
//         }
//     }

//     useEffect(() => {
//         getOutlets();
//         getCategoryList();
//         getProductsList();
//         getAddons();
//     }, []);

//     useEffect(() => {
//         const now = new Date();
//         const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
//         const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
//         const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
//         const end = new Date(currentDate.setHours(23, 59, 59, 999));
//         setStartDate(start);
//         setEndDate(end);
//     }, []);

//     useEffect(() => {
//         if (addonGroup) {
//             const selectedGroup = addons.find(addon => addon._id === addonGroup.value);
//             if (selectedGroup && Array.isArray(selectedGroup.addonValues)) {
//                 const values = selectedGroup.addonValues.map(val => ({
//                     value: val._id,
//                     label: val.value,
//                 }));
//                 setFilteredAddonValues(values);
//             } else {
//                 setFilteredAddonValues([]);
//             }
//         } else {
//             setFilteredAddonValues([]);
//             setSelectedAddonValue(null);
//         }
//     }, [addonGroup, addons]);

//     const outletOptions = outlets?.map((outlet) => ({
//         value: outlet._id,
//         label: `${outlet.name} (${outlet.city})`,
//     }));

//     const categoryOptions = categoryList.map((category) => ({
//         value: category._id,
//         label: category.name,
//     }));

//     const handleEndDateChange = (date) => {
//         const start = new Date(startDate);
//         const end = new Date(date);
//         start.setHours(0, 0, 0, 0);
//         end.setHours(0, 0, 0, 0);
//         const maxEndDate = new Date(start);
//         maxEndDate.setDate(start.getDate() + MAX_DATE_RANGE_DAYS);
//         if (maxEndDate && startDate && maxEndDate < startDate) {
//             setError('End date cannot be earlier than start date');
//         } else {
//             setError('');
//             setEndDate(date);
//         }
//     };

//     const handleDownload = async (withCosting) => {
//         if (!selectedOutlet || !startDate || !endDate) {
//             toast.error("Please select outlet, start date, and end date");
//             return;
//         }

//         setDownloading(true);
//         try {
//             const formatDate = (date) => {
//                 return new Date(date).toISOString().split('T')[0];
//             };
//             const params = {
//                 isDownload: true,
//                 isCosting: withCosting,
//                 outlet: selectedOutlet.value,
//                 startDate: formatDate(startDate),
//                 endDate: formatDate(endDate)
//             };

//             if (selectedCategory) params.category = selectedCategory;
//             if (productId) params.product = productId;
//             if (addonGroup) params.addonGroupId = addonGroup.value;
//             if (selectedAddonValue) params.addonValueId = selectedAddonValue.value;

//             const response = await axiosInstance.get('/product-addon/getProductAddonSales', {
//                 params: params,
//                 responseType: 'blob'
//             });

//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             const fileName = `product_addon_report_${withCosting ? 'with' : 'without'}_costing_${formatDate(startDate)}_to_${formatDate(endDate)}.xlsx`;
//             link.setAttribute('download', fileName);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//             window.URL.revokeObjectURL(url);

//             setShowProductAddonModal(false);
//             setSelectedOutlet('');
//             setSelectedCategory('');
//             setProductId('');
//             setAddonGroup('');
//             setSelectedAddonValue('');
//             toast.success("Report downloaded successfully!");

//         } catch (error) {
//             toast.error("Error downloading report");
//         } finally {
//             setDownloading(false);
//         }
//     };

//     if (selectedReport && !selectedReport.isModal) {
//         return (
//             <React.Fragment>
//                 <Header onSkin={setSkin} />
//                 <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
//                     <button 
//                         onClick={handleBackClick}
//                         className={`btn ${skin === "dark" ? "btn-outline-light" : "btn-outline-dark"} mb-4 d-flex align-items-center`}
//                     >
//                         <ArrowLeft className="me-2" /> Back to All Reports
//                     </button>

//                     <div className="d-flex align-items-center mb-4">
//                         <div className="report-icon me-3" style={{ backgroundColor: `${selectedReport.color}20`, color: selectedReport.color }}>
//                             {selectedReport.icon || <BarChart size={24} />}
//                         </div>
//                         <h2 className="mb-0">{selectedReport.name}</h2>
//                     </div>

//                     <div className={`p-4 rounded-3 ${skin === "dark" ? "bg-gray-800" : "bg-white"} shadow-sm`}>
//                         <p>Report content will be displayed here.</p>
//                     </div>
//                 </div>
//             </React.Fragment>
//         );
//     }

//     return (
//         <React.Fragment>
//             <Header onSkin={setSkin} />
//             <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
//                 <div className="all-reports-container">
//                     {/* Header Section */}
//                     <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
//                         <div>
//                             <h3 className="mb-0" style={{ fontSize: "24px", fontWeight: "600" }}>ALL REPORTS</h3>
//                             <p className={`text-${skin === "dark" ? "light-50" : "muted"} mb-0 mt-1`}>
//                                 {totalFilteredReports} reports available
//                             </p>
//                         </div>

//                         {/* Search Bar */}
//                         <div style={{ minWidth: "280px" }}>
//                             <InputGroup>
//                                 <InputGroup.Text className={skin === "dark" ? "bg-gray-800 border-secondary text-light" : ""}>
//                                     <Search size={16} />
//                                 </InputGroup.Text>
//                                 <Form.Control
//                                     type="text"
//                                     placeholder="Search reports..."
//                                     value={searchTerm}
//                                     onChange={(e) => setSearchTerm(e.target.value)}
//                                     className={skin === "dark" ? "bg-gray-800 text-light border-secondary" : ""}
//                                 />
//                                 {searchTerm && (
//                                     <Button
//                                         variant="outline-secondary"
//                                         onClick={() => setSearchTerm('')}
//                                         className={skin === "dark" ? "border-secondary" : ""}
//                                     >
//                                         <X size={14} />
//                                     </Button>
//                                 )}
//                             </InputGroup>
//                         </div>
//                     </div>

//                     {/* Group Filter Tabs */}
//                     <div className="d-flex flex-wrap gap-2 mb-4">
//                         <button
//                             onClick={() => setActiveGroup('all')}
//                             className={`btn btn-sm ${activeGroup === 'all' ? 'btn-primary' : `btn-outline-${skin === "dark" ? "light" : "secondary"}`}`}
//                         >
//                             <Grid size={14} className="me-1" /> All Reports
//                         </button>
//                         {Object.entries(reportGroups).map(([key, group]) => (
//                             <button
//                                 key={key}
//                                 onClick={() => setActiveGroup(key)}
//                                 className={`btn btn-sm ${activeGroup === key ? 'btn-primary' : `btn-outline-${skin === "dark" ? "light" : "secondary"}`}`}
//                             >
//                                 {group.icon}
//                                 <span className="ms-1">{group.name}</span>
//                             </button>
//                         ))}
//                     </div>

//                     {/* Search Results Info */}
//                     {searchTerm && (
//                         <div className={`alert ${skin === "dark" ? "alert-secondary bg-gray-800" : "alert-info"} mb-4 py-2`}>
//                             Found <strong>{totalFilteredReports}</strong> report{totalFilteredReports !== 1 ? 's' : ''} matching "{searchTerm}"
//                         </div>
//                     )}

//                     {/* Report Groups Display */}
//                     {Object.entries(reportGroups).map(([groupKey, group]) => {
//                         const filteredGroupReports = getFilteredReportsForGroup(group.reports);

//                         if (filteredGroupReports?.length === 0) return null;
//                         if (activeGroup !== 'all' && activeGroup !== groupKey) return null;

//                         return (
//                             <div key={groupKey} className="mb-5">
//                                 <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
//                                     <div 
//                                         className="p-2 rounded me-2 d-flex align-items-center justify-content-center"
//                                         style={{ backgroundColor: `${group.color}15`, color: group.color }}
//                                     >
//                                         {group.icon}
//                                     </div>
//                                     <h4 className="mb-0" style={{ fontSize: "18px", fontWeight: "600" }}>
//                                         {group.name}
//                                     </h4>
//                                     <span className={`ms-2 badge ${skin === "dark" ? "bg-secondary" : "bg-light text-dark"}`}>
//                                         {filteredGroupReports.length}
//                                     </span>
//                                 </div>

//                                 <div className="row g-4">
//                                     {filteredGroupReports.map((report, index) => (
//                                         <div key={index} className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
//                                             <div 
//                                                 className={`card h-100 report-card border-0 ${skin === "dark" ? "bg-gray-800" : "bg-white"} shadow-sm`}
//                                                 onClick={() => handleReportClick(report)}
//                                                 style={{ cursor: "pointer", borderRadius: "12px" }}
//                                             >
//                                                 <div className="card-body p-4">
//                                                     <div className="d-flex align-items-start">
//                                                         <div 
//                                                             className="report-icon me-3 d-flex align-items-center justify-content-center"
//                                                             style={{ 
//                                                                 backgroundColor: `${report.color}15`, 
//                                                                 color: report.color,
//                                                                 width: "48px",
//                                                                 height: "48px",
//                                                                 borderRadius: "12px"
//                                                             }}
//                                                         >
//                                                             {React.cloneElement(report.icon, { size: 24 })}
//                                                         </div>
//                                                         <div className="flex-grow-1">
//                                                             <h6 className="card-title mb-1" style={{ fontSize: "15px", fontWeight: "600" }}>
//                                                                 {report.name}
//                                                             </h6>
//                                                             {report.description && (
//                                                                 <small className={`text-${skin === "dark" ? "light-50" : "muted"} d-block`}>
//                                                                     {report.description}
//                                                                 </small>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className={`card-footer ${skin === "dark" ? "bg-gray-700" : "bg-light"} border-0 py-2 px-4`}>
//                                                     <small className={`text-${skin === "dark" ? "light" : "muted"} d-flex align-items-center`}>
//                                                         <BarChart className="me-1" size={12} /> View Report
//                                                     </small>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         );
//                     })}

//                     {/* No Results */}
//                     {totalFilteredReports === 0 && (
//                         <div className={`text-center py-5 ${skin === "dark" ? "text-light" : "text-muted"}`}>
//                             <Search size={48} className="mb-3 opacity-50" />
//                             <h5>No reports found</h5>
//                             <p>No reports matching "{searchTerm}" were found.</p>
//                             <Button variant="outline-primary" onClick={() => setSearchTerm('')} size="sm">
//                                 Clear Search
//                             </Button>
//                         </div>
//                     )}

//                     {/* Transactions Section */}
//                     {filteredTransactions?.length > 0 && (
//                         <>
//                             <hr className="my-4" />
//                             <div className="mb-4">
//                                 <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
//                                     <div className="p-2 rounded me-2 d-flex align-items-center justify-content-center" style={{ backgroundColor: "#e74a3b15", color: "#e74a3b" }}>
//                                         <Layers size={18} />
//                                     </div>
//                                     <h4 style={{ fontSize: "18px", fontWeight: "600" }}>TRANSACTIONS</h4>
//                                 </div>
//                                 <div className="row g-4">
//                                     {filteredTransactions.map((tran, index) => (
//                                         <div key={index} className="col-xl-4 col-lg-4 col-md-6">
//                                             <div 
//                                                 className={`card h-100 report-card border-0 ${skin === "dark" ? "bg-gray-800" : "bg-white"} shadow-sm`}
//                                                 onClick={() => handleTransactionClick(tran)}
//                                                 style={{ cursor: "pointer", borderRadius: "12px" }}
//                                             >
//                                                 <div className="card-body p-4">
//                                                     <div className="d-flex align-items-start">
//                                                         <div 
//                                                             className="report-icon me-3 d-flex align-items-center justify-content-center"
//                                                             style={{ 
//                                                                 backgroundColor: `${tran.color}15`, 
//                                                                 color: tran.color,
//                                                                 width: "48px",
//                                                                 height: "48px",
//                                                                 borderRadius: "12px"
//                                                             }}
//                                                         >
//                                                             {React.cloneElement(tran.icon, { size: 24 })}
//                                                         </div>
//                                                         <div className="flex-grow-1">
//                                                             <h6 className="card-title mb-1" style={{ fontSize: "15px", fontWeight: "600" }}>
//                                                                 {tran.name}
//                                                             </h6>
//                                                             {tran.description && (
//                                                                 <small className={`text-${skin === "dark" ? "light-50" : "muted"} d-block`}>
//                                                                     {tran.description}
//                                                                 </small>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className={`card-footer ${skin === "dark" ? "bg-gray-700" : "bg-light"} border-0 py-2 px-4`}>
//                                                     <small className={`text-${skin === "dark" ? "light" : "muted"} d-flex align-items-center`}>
//                                                         <BarChart className="me-1" size={12} /> View Transactions
//                                                     </small>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         </>
//                     )}
//                 </div>
//             </div>

//             {/* Product Addon Report Modal */}
//             <Modal 
//                 show={showProductAddonModal} 
//                 onHide={handleCloseModal}
//                 centered
//                 size="lg"
//                 className={skin === "dark" ? "dark-modal" : ""}
//             >
//                 <Modal.Header closeButton className={skin === "dark" ? "bg-gray-800 text-light border-secondary" : ""}>
//                     <Modal.Title>
//                         <div className="d-flex align-items-center">
//                             <FileText size={24} className="me-2" style={{ color: "#9b59b6" }} />
//                             Generate Product + Addon Report
//                         </div>
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body className={skin === "dark" ? "bg-gray-800 text-light" : ""}>
//                     <Form>
//                         <Row>
//                             <Col md={12} className='mb-3'>
//                                 <Form.Group controlId="outletSelect">

//                                     <OutletSelect
//                                         value={selectedOutlet}
//                                         onChange={(option) => setSelectedOutlet(option)}
//                                         required={true}
//                                     />
//                                 </Form.Group>
//                             </Col>
//                             <Col md={6} className='mb-3'>
//                                 <Form.Group className='d-flex flex-column' controlId="startDate">
//                                     <Form.Label className="fw-semibold">Start Date <span className='text-danger'>*</span></Form.Label>
//                                     <DatePicker
//                                         selected={startDate}
//                                         onChange={(date) => setStartDate(date)}
//                                         dateFormat="dd-MM-yyyy"
//                                         className="form-control"
//                                     />
//                                 </Form.Group>
//                             </Col>
//                             <Col md={6} className='mb-3'>
//                                 <Form.Group className='d-flex flex-column' controlId="endDate">
//                                     <Form.Label className="fw-semibold">End Date <span className='text-danger'>*</span></Form.Label>
//                                     <DatePicker
//                                         selected={endDate}
//                                         onChange={handleEndDateChange}
//                                         dateFormat="dd-MM-yyyy"
//                                         minDate={startDate}
//                                         className="form-control"
//                                     />
//                                     {error && <div className="text-danger small mt-1">{error}</div>}
//                                 </Form.Group>
//                             </Col>
//                         </Row>

//                         <Row>
//                             <Col md={6} className='mb-3'>
//                                 <Form.Group controlId="categorySelect">
//                                     <Form.Label className="fw-semibold">Category</Form.Label>
//                                     <Select
//                                         options={categoryOptions}
//                                         value={categoryOptions.find(option => option.value === selectedCategory) || null}
//                                         onChange={(selectedOption) => {
//                                             const selectCategory = selectedOption?.value || '';
//                                             setSelectedCategory(selectCategory);
//                                             setProductId('');
//                                             if (!selectCategory) {
//                                                 setFilteredProducts(productsList || []);
//                                             } else {
//                                                 setFilteredProducts(
//                                                     (productsList || []).filter(
//                                                         (product) => product?.category?._id === selectCategory
//                                                     )
//                                                 );
//                                             }
//                                         }}
//                                         isClearable
//                                         styles={customStyles}
//                                         placeholder="Select Category"
//                                     />
//                                 </Form.Group>
//                             </Col>
//                             <Col md={6} className='mb-3'>
//                                 <Form.Group controlId="productSelect">
//                                     <Form.Label className="fw-semibold">Menu Item</Form.Label>
//                                     <Select
//                                         options={filteredProducts?.map((product) => ({
//                                             value: product._id,
//                                             label: product.name,
//                                         })) || []}
//                                         value={productId ? { value: productId, label: filteredProducts.find((p) => p._id === productId)?.name } : null}
//                                         onChange={(selectedOption) => setProductId(selectedOption ? selectedOption.value : '')}
//                                         isClearable
//                                         styles={customStyles}
//                                         placeholder="Select Menu Item"
//                                     />
//                                 </Form.Group>
//                             </Col>
//                         </Row>

//                         <Row>
//                             <Col md={6} className='mb-3'>
//                                 <Form.Label className="fw-semibold">Addon Group</Form.Label>
//                                 <Select
//                                     options={addons?.map((addon) => ({
//                                         value: addon?._id,
//                                         label: addon?.title,
//                                     }))}
//                                     value={addonGroup}
//                                     onChange={(selectedOption) => {
//                                         setAddonGroup(selectedOption || null);
//                                         setSelectedAddonValue(null);
//                                     }}
//                                     isClearable
//                                     placeholder="Select Addon Group"
//                                 />
//                             </Col>
//                             <Col md={6} className='mb-3'>
//                                 <Form.Label className="fw-semibold">Addon Values</Form.Label>
//                                 <Select
//                                     components={animatedComponents}
//                                     options={filteredAddonValues}
//                                     value={selectedAddonValue}
//                                     onChange={handleAddonValueChange}
//                                     placeholder="Select Addon Value"
//                                     isClearable
//                                     isDisabled={!addonGroup}
//                                 />
//                             </Col>
//                         </Row>

//                         <div className="d-flex justify-content-end gap-2 mt-4">
//                             <Button variant="outline-secondary" onClick={handleCloseModal}>
//                                 Cancel
//                             </Button>
//                             <DropdownButton
//                                 variant="primary"
//                                 title={downloading ? <Spinner size="sm" /> : 'Download Report'}
//                                 disabled={!selectedOutlet || !startDate || !endDate || downloading}
//                                 align="end"
//                             >
//                                 <Dropdown.Item onClick={() => handleDownload(false)}>
//                                     Download without costing
//                                 </Dropdown.Item>
//                                 <Dropdown.Item onClick={() => handleDownload(true)}>
//                                     Download with costing
//                                 </Dropdown.Item>
//                             </DropdownButton>
//                         </div>
//                     </Form>
//                 </Modal.Body>
//             </Modal>

//             <style>{`
//                 .report-card {
//                     transition: transform 0.2s, box-shadow 0.2s;
//                 }
//                 .report-card:hover {
//                     transform: translateY(-1px);
//                     box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important;
//                 }
//                 .bg-gray-800 {
//                     background-color: #1e1e2d !important;
//                 }
//                 .bg-gray-700 {
//                     background-color: #2a2a3a !important;
//                 }
//                 .text-light-50 {
//                     color: rgba(255, 255, 255, 0.5) !important;
//                 }
//                 .dark-modal .modal-content {
//                     background-color: #1e1e2d;
//                     color: #fff;
//                 }
//                 .dark-modal .modal-header,
//                 .dark-modal .modal-footer {
//                     border-color: #2a2a3a;
//                 }
//                 .dark-modal .form-control,
//                 .dark-modal .form-select {
//                     background-color: #2a2a3a;
//                     border-color: #3a3a4a;
//                     color: #fff;
//                 }
//                 .dark-modal .form-control:focus {
//                     background-color: #2a2a3a;
//                     border-color: #4e73df;
//                     color: #fff;
//                 }
//                 .dark-modal .btn-close {
//                     filter: invert(1);
//                 }
//             `}</style>
//         </React.Fragment>
//     );
// };

// export default AllReports;

import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../layouts/Header';
import {
    ArrowLeft,
    BarChart,
    People,
    Cart,
    Person,
    PieChart,
    Tag,
    Calendar,
    CurrencyDollar,
    Box,
    ListUl,
    Clipboard,
    Shop,
    Box2,
    CartX,
    Bank,
    Archive,
    CartCheck,
    FileText,
    Download,
    X,
    FileEarmarkSpreadsheet,
    Search,
    Grid,
    Layers,
    GraphUp,
    Ticket,
    BoxSeam,
    CashStack,
    Receipt,
    Tags
} from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';
import { Modal, Button, Form, Row, Col, DropdownButton, Dropdown, Spinner, InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import axiosInstance from '../../api/axios';import makeAnimated from "react-select/animated";
import OutletSelect from '../../components/OutletSelect';
import { MAX_DATE_RANGE_DAYS, DATE_RANGE_ERROR_MESSAGE } from '../../constants/dateConstants';
import { ShoppingCart, TrendingUp } from 'lucide-react';

const AllReports = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const accessToken = localStorage.getItem("accessToken");
    const animatedComponents = makeAnimated();

    const navigate = useNavigate();
    const [selectedReport, setSelectedReport] = useState(null);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const { access } = useSelector((state) => state.login);
    const [searchTerm, setSearchTerm] = useState('');
    // const [activeGroup, setActiveGroup] = useState('all');
    const [activeGroup, setActiveGroup] = useState(() => sessionStorage.getItem('reportsActiveGroup') || 'all');

    // State for Product Addon Report Modal
    const [showProductAddonModal, setShowProductAddonModal] = useState(false);

    // State for Online Sales Report Modal
    const [showOnlineSalesModal, setShowOnlineSalesModal] = useState(false);
    const [onlineSalesOutlet, setOnlineSalesOutlet] = useState('');
    const [onlineSalesPlatform, setOnlineSalesPlatform] = useState('');
    const [onlineSalesStartDate, setOnlineSalesStartDate] = useState('');
    const [onlineSalesEndDate, setOnlineSalesEndDate] = useState('');
    const [onlineSalesCategory, setOnlineSalesCategory] = useState('');
    const [onlineSalesDownloading, setOnlineSalesDownloading] = useState(false);
    const [onlineSalesError, setOnlineSalesError] = useState('');

    const [outlets, setOutlets] = useState([]);

    // Filters States
    const [selectedOutlet, setSelectedOutlet] = useState('');
    const [selectedOutletName, setSelectedOutletName] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [categoryList, setCategoryList] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedCategoryName, setselectedCategoryName] = useState('');
    const [productsList, setProductsList] = useState([]);
    const [productId, setProductId] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [addonGroup, setAddonGroup] = useState([]);
    const [addons, setAddons] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);
    const [selectedAddonValue, setSelectedAddonValue] = useState([]);

    const [downloading, setDownloading] = useState(false);
    const [error, setError] = useState('');

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
    };

    // Define report groups
    const reportGroups = {
        sales: {
            name: "Order & Sales",
            icon: <Cart size={18} />,
            color: "#1cc88a",
            reports: [
                { path: "/reports/order-reports", name: "Order Report", icon: <Cart size={20} />, color: "#1cc88a", accessKey: "OrdersReport:get", description: "View all order details" },
                { path: "/reports/product-sales-report", name: "Product Sales Report", icon: <CurrencyDollar size={20} />, color: "#4e73df", accessKey: "ProductSalesReport:get", description: "Product wise sales analysis"},
                {
                    path: "#",
                    name: "Online Sales Report",
                    icon: <TrendingUp size={20} />,
                    color: "#4e73df",
                    accessKey: "OnlineSalesReport:get",
                    description: "Zomato and Swiggy sales analysis",
                    isModal: true,
                    modalType: "onlineSales"
                },
                { path: "/reports/marketing-reports", name: "Marketing Report", icon: <GraphUp size={20} />, color: "#1cc88a", accessKey: "MarketingReport:get", description: "View all marketing details" },
                { path: "/reports/product-costing-report", name: "Product Costing Report", icon: <Tags size={20} />, color: "#1cc88a", accessKey: "ProductCostingReport:get", description: "Overview of Product Costing", isNew: true },
                // { path: "/reports/item-wise-report", name: "Item Wise Report", icon: <ListUl size={20} />, color: "#36b9cc", accessKey: "ItemWiseReport:get", description: "Item wise sales breakdown" },
                { path: "/reports/addon-sales-report", name: "Addon Sales Report", icon: <Clipboard size={20} />, color: "#e74a3b", accessKey: "AddonSalesReport:get", description: "Addon sales analytics", isNew: true },
                {
                    path: "#",
                    name: "Product + Addon Report",
                    icon: <FileText size={20} />,
                    color: "#9b59b6",
                    accessKey: "ProductAddonSales:get",
                    description: "Combined product and addon sales",
                    isModal: true,
                    modalType: "productAddon"
                },
            ]
        },
        customers: {
            name: "Customer & User",
            icon: <People size={18} />,
            color: "#36b9cc",
            reports: [
                { path: "/reports/customer-reports", name: "Customer Report", icon: <People size={20} />, color: "#4e73df", accessKey: "CustomerReport:get", description: "Customer data and analytics" },
                // { path: "/reports/kiosk-user-reports", name: "Kiosk User Report", icon: <Person size={20} />, color: "#36b9cc", accessKey: "KioskUserReport:get", description: "Kiosk user statistics" },
                { path: "/reports/user-analytics-reports", name: "User Analytics Report", icon: <PieChart size={20} />, color: "#f6c23e", accessKey: "UserAnalyticsReport:get", description: "User behavior analytics" },
            ]
        },
        coupons: {
            name: "Coupons & Promotions",
            icon: <Tag size={18} />,
            color: "#e74a3b",
            reports: [
                { path: "/reports/coupons-report", name: "Coupons Report", icon: <Tag size={20} />, color: "#e74a3b", accessKey: "CouponsReport:get", description: "Coupon usage and performance", isNew: true  },
                { path: "/reports/journey-revenue-report", name: "Journey Revenue Report", icon: <CurrencyDollar size={20} />, color: "#f6c23e", accessKey: "JourneyCouponRevenueReport:get", description: "Revenue from journeys", isNew: true },
                // { path: "/reports/journey-coupon-report", name: "Journey Coupon Report", icon: <Tag size={20} />, color: "#e74a3b", accessKey: "JourneyCouponReport:get", description: "Journey based coupon analytics" },
                { path: "/reports/user-coupon-report", name: "User Coupon Report", icon: <Tag size={20} />, color: "#1cc88a", accessKey: "UserCouponReport:get", description: "User wise coupon usage" },
            ]
        },
        summary: {
            name: "Summary & Analytics",
            icon: <BarChart size={18} />,
            color: "#f6c23e",
            reports: [
                { path: "/reports/day-summary-report", name: "Day Summary", icon: <Calendar size={20} />, color: "#5a5c69", accessKey: "DaySummaryReport:get", description: "Daily business summary", isNew: true },
                { path: "/reports/month-summary-report", name: "Month Summary", icon: <Calendar size={20} />, color: "#858796", accessKey: "MonthSummaryReport:get", description: "Monthly business summary" },
            ]
        },
        inventory: {
            name: "Inventory & Stock",
            icon: <Box size={18} />,
            color: "#4e73df",
            reports: [
                { path: "/reports/outlet-stock-report", name: "Outlet Stock Transfer Report", icon: <Shop size={20} />, color: "#e74a3b", accessKey: "OutletStockReport:get", description: "Current outlet stock levels", isNew: true },
                { path: "/reports/outlet-inventory-report", name: "Outlet Inventory Status", icon: <Shop size={20} />, color: "#1cc88a", accessKey: "OutletInventoryReport:get", description: "Outlet inventory details" },
                { path: "/reports/storage-location-stock-report", name: "Storage Location Stock", icon: <Box2 size={20} />, color: "#e74a3b", accessKey: "StorageLocationStockReport:get", description: "Storage wise stock status", isNew: true },
                { path: "/reports/stock-consumption-report", name: "Stock Usage Report", icon: <Calendar size={20} />, color: "#858796", accessKey: "StockConsumptionReport:get", description: "Stock consumption patterns" },
                // { path: "/reports/rm-reorder-report", name: "Raw Material Reorder Alert", icon: <Box size={20} />, color: "#f6c23e", accessKey: "RMReorderReport:get", description: "Reorder level monitoring" },
                { path: "/reports/out-of-stock-product-report", name: "Out of Stock Products", icon: <CartX size={20} />, color: "#e74a3b", accessKey: "ProductOutofStockReport:get", description: "Out of stock products" },
                // { path: "/reports/rm-stock-report", name: "Central Raw Material Stock", icon: <Archive size={20} />, color: "#e74a3b", accessKey: "RMCentralStockReport:get", description: "Central stock status" },
            ]
        },
        subscription: {
            name: "Subscription",
            icon: <CartCheck size={18} />,
            color: "#9b59b6",
            reports: [
                { path: "/reports/subscription-purchase-report", name: "Subscription Purchase", icon: <CartCheck size={20} />, color: "#1cc88a", accessKey: "SubscriptionPurchaseReport:get", description: "Subscription purchases" },
                // { path: "/subscription/subscription-users", name: "Subscription Purchase", icon: <CartCheck size={20} />, color: "#1cc88a", accessKey: "SubscriptionPurchaseReport:get", description: "Subscription purchases" },
                { path: "/reports/subscription-consumption-report", name: "Subscription Consumption", icon: <BarChart size={20} />, color: "#5a5c69", accessKey: "SubscriptionConsumptionReport:get", description: "Subscription usage" },
            ]
        }
    };

    const transactions = [
        { path: "/transaction/central-stock-report", name: "Central Stock Transactions", icon: <Bank size={20} />, color: "#e74a3b", accessKey: "CentralStockTransaction:get", description: "Central stock movements" },
        { path: "/transaction/outlet-stock-report", name: "Outlet Stock Transactions", icon: <Archive size={20} />, color: "#e74a3b", accessKey: "OutletStockTransaction:get", description: "Outlet stock movements" }
    ];

    // Filter reports based on user access and search term
    const getFilteredReportsForGroup = (groupReports) => {
        let filtered = access === null || access?.length === 0 || access === undefined
            ? groupReports
            : groupReports.filter(report => access?.includes(report?.accessKey));

        if (searchTerm) {
            filtered = filtered.filter(report =>
                report.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        return filtered;
    };

    const filteredTransactions = access === null || access?.length === 0 || access === undefined
        ? transactions
        : transactions.filter(tran => access?.includes(tran?.accessKey));

    // Get total count of filtered reports
    const totalFilteredReports = useMemo(() => {
        let total = 0;
        Object.keys(reportGroups).forEach(groupKey => {
            total += getFilteredReportsForGroup(reportGroups[groupKey].reports).length;
        });
        return total;
    }, [searchTerm, access]);

    const handleReportClick = (report) => {
        if (report.isModal && report.modalType === "productAddon") {
            setShowProductAddonModal(true);
        } else if (report.isModal && report.modalType === "onlineSales") {
            setShowOnlineSalesModal(true);
        } else {
            sessionStorage.setItem('reportsActiveGroup', activeGroup); // ← persist before navigating
            setSelectedReport(report);
            navigate(report.path);
        }
    };

    const handleTransactionClick = (transaction) => {
        setSelectedTransaction(transaction);
        navigate(transaction.path);
    };

    const handleBackClick = () => {
        setSelectedReport(null);
        setSelectedTransaction(null);
        navigate("/reports/all-reports");
    };

    const handleCloseModal = () => {
        setShowProductAddonModal(false);
        setSelectedOutlet('');
    };

    // Online Sales Modal handlers
    const handleCloseOnlineSalesModal = () => {
        setShowOnlineSalesModal(false);
        setOnlineSalesOutlet('');
        setOnlineSalesPlatform('');
        setOnlineSalesStartDate('');
        setOnlineSalesEndDate('');
        setOnlineSalesCategory('');
        setOnlineSalesError('');
    };

    const handleOnlineSalesDownload = async (withCosting) => {
        if (!onlineSalesOutlet || !onlineSalesStartDate || !onlineSalesEndDate) {
            toast.error("Please select outlet, start date, and end date");
            return;
        }

        setOnlineSalesDownloading(true);
        try {
            const formatDate = (date) => new Date(date).toISOString().split('T')[0];

            let url = `third-party-sales?outlet=${onlineSalesOutlet.value}&startDate=${formatDate(onlineSalesStartDate)}&endDate=${formatDate(onlineSalesEndDate)}&isDownload=true&isCosting=${withCosting}`;
            if (onlineSalesPlatform) url += `&platform=${onlineSalesPlatform}`;
            if (onlineSalesCategory) url += `&category=${onlineSalesCategory}`;

            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get(url, {
                headers,
                responseType: 'blob'
            });

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            const platformLabel = onlineSalesPlatform || 'All Platforms';
            link.download = `Online_Sales_Report_${platformLabel}_${withCosting ? 'with' : 'without'}_costing_${formatDate(onlineSalesStartDate)}_to_${formatDate(onlineSalesEndDate)}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(link.href);

            toast.success("Online Sales Report downloaded successfully!");
            handleCloseOnlineSalesModal();
        } catch (error) {
            console.error("Error downloading online sales report:", error);
            toast.error("Error downloading report. Please try again.");
        } finally {
            setOnlineSalesDownloading(false);
        }
    };

    const handleAddonValueChange = (e) => {
        setSelectedAddonValue(e);
    }

    const getOutlets = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("outlet", { headers });
            if (response?.data?.status === true) {
                const activeOutlets = response?.data?.data?.outlets.filter((active) => active?.status === "ACTIVE" || "INACTIVE");
                setOutlets(activeOutlets);
            }
        } catch (error) {
            console.error("Error fetching outlets:", error);
        }
    };

    const getCategoryList = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("masters/category/get", { headers });
            if (response?.data?.status === true) {
                setCategoryList(response?.data?.data?.categories || []);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const getProductsList = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("product", { headers });
            if (response?.data?.status === true) {
                setProductsList(response?.data?.data?.products || []);
                setFilteredProducts(response?.data?.data?.products || []);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };

    const getAddons = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("addons?page=1&limit=1000", { headers });
            setAddons(response?.data?.data?.addons);
        } catch (error) {
            console.error("Error fetching addons:", error);
        }
    }

    useEffect(() => {
        getOutlets();
        getCategoryList();
        getProductsList();
        getAddons();
    }, []);

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));
        setStartDate(start);
        setEndDate(end);
        setOnlineSalesStartDate(start);
        setOnlineSalesEndDate(end);
    }, []);

    useEffect(() => {
        if (addonGroup) {
            const selectedGroup = addons.find(addon => addon._id === addonGroup.value);
            if (selectedGroup && Array.isArray(selectedGroup.addonValues)) {
                const values = selectedGroup.addonValues.map(val => ({
                    value: val._id,
                    label: val.value,
                }));
                setFilteredAddonValues(values);
            } else {
                setFilteredAddonValues([]);
            }
        } else {
            setFilteredAddonValues([]);
            setSelectedAddonValue(null);
        }
    }, [addonGroup, addons]);

    const outletOptions = outlets?.map((outlet) => ({
        value: outlet._id,
        label: `${outlet.name} (${outlet.city})`,
    }));

    const categoryOptions = categoryList.map((category) => ({
        value: category._id,
        label: category.name,
    }));

    const handleEndDateChange = (date) => {
        const start = new Date(startDate);
        const end = new Date(date);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        const maxEndDate = new Date(start);
        maxEndDate.setDate(start.getDate() + MAX_DATE_RANGE_DAYS);
        if (maxEndDate && startDate && maxEndDate < startDate) {
            setError('End date cannot be earlier than start date');
        } else {
            setError('');
            setEndDate(date);
        }
    };

    const handleDownload = async (withCosting) => {
        if (!selectedOutlet || !startDate || !endDate) {
            toast.error("Please select outlet, start date, and end date");
            return;
        }

        setDownloading(true);
        try {
            const formatDate = (date) => {
                return new Date(date).toISOString().split('T')[0];
            };
            const params = {
                isDownload: true,
                isCosting: withCosting,
                outlet: selectedOutlet.value,
                startDate: formatDate(startDate),
                endDate: formatDate(endDate)
            };

            if (selectedCategory) params.category = selectedCategory;
            if (productId) params.product = productId;
            if (addonGroup) params.addonGroupId = addonGroup.value;
            if (selectedAddonValue) params.addonValueId = selectedAddonValue.value;

            const response = await axiosInstance.get('/product-addon/getProductAddonSales', {
                params: params,
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const fileName = `product_addon_report_${withCosting ? 'with' : 'without'}_costing_${formatDate(startDate)}_to_${formatDate(endDate)}.xlsx`;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            setShowProductAddonModal(false);
            setSelectedOutlet('');
            setSelectedCategory('');
            setProductId('');
            setAddonGroup('');
            setSelectedAddonValue('');
            toast.success("Report downloaded successfully!");

        } catch (error) {
            toast.error("Error downloading report");
        } finally {
            setDownloading(false);
        }
    };

    if (selectedReport && !selectedReport.isModal) {
        return (
            <React.Fragment>
                <Header onSkin={setSkin} />
                <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                    <button
                        onClick={handleBackClick}
                        className={`btn ${skin === "dark" ? "btn-outline-light" : "btn-outline-dark"} mb-4 d-flex align-items-center`}
                    >
                        <ArrowLeft className="me-2" /> Back to All Reports
                    </button>

                    <div className="d-flex align-items-center mb-4">
                        <div className="report-icon me-3" style={{ backgroundColor: `${selectedReport.color}20`, color: selectedReport.color }}>
                            {selectedReport.icon || <BarChart size={24} />}
                        </div>
                        <h2 className="mb-0">{selectedReport.name}</h2>
                    </div>

                    <div className={`p-4 rounded-3 ${skin === "dark" ? "bg-gray-800" : "bg-white"} shadow-sm`}>
                        <p>Report content will be displayed here.</p>-
                    </div>
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                <div className="all-reports-container">
                    {/* Header Section */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                        <div>
                            <h3 className="mb-0" style={{ fontSize: "24px", fontWeight: "600" }}>ALL REPORTS</h3>
                            <p className={`text-${skin === "dark" ? "light-50" : "muted"} mb-0 mt-1`}>
                                {totalFilteredReports} reports available
                            </p>
                        </div>

                        {/* Search Bar */}
                        <div style={{ minWidth: "280px" }}>
                            <InputGroup>
                                <InputGroup.Text className={skin === "dark" ? "bg-gray-800 border-secondary text-light" : ""}>
                                    <Search size={16} />
                                </InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    placeholder="Search reports..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className={skin === "dark" ? "bg-gray-800 text-light border-secondary" : ""}
                                />
                                {searchTerm && (
                                    <Button
                                        variant="outline-secondary"
                                        onClick={() => setSearchTerm('')}
                                        className={skin === "dark" ? "border-secondary" : ""}
                                    >
                                        <X size={14} />
                                    </Button>
                                )}
                            </InputGroup>
                        </div>
                    </div>

                    {/* Group Filter Tabs */}
                    <div className="d-flex flex-wrap gap-2 mb-4">
                        <button
                            // onClick={() => setActiveGroup('all')}
                            onClick={() => {
                                setActiveGroup('all');
                                sessionStorage.setItem('reportsActiveGroup', 'all');
                            }}
                            className={`btn btn-sm ${activeGroup === 'all' ? 'btn-primary' : `btn-outline-${skin === "dark" ? "light" : "secondary"}`}`}
                        >
                            <Grid size={14} className="me-1" /> All Reports
                        </button>
                        {Object.entries(reportGroups).map(([key, group]) => (
                            <button
                                key={key}
                                onClick={() => {
                                    setActiveGroup(key);
                                    sessionStorage.setItem('reportsActiveGroup', key);
                                }}
                                // onClick={() => setActiveGroup(key)}
                                className={`btn btn-sm ${activeGroup === key ? 'btn-primary' : `btn-outline-${skin === "dark" ? "light" : "secondary"}`}`}
                            >
                                {group.icon}
                                <span className="ms-1">{group.name}</span>
                            </button>
                        ))}
                    </div>

                    {/* Search Results Info */}
                    {searchTerm && (
                        <div className={`alert ${skin === "dark" ? "alert-secondary bg-gray-800" : "alert-info"} mb-4 py-2`}>
                            Found <strong>{totalFilteredReports}</strong> report{totalFilteredReports !== 1 ? 's' : ''} matching "{searchTerm}"
                        </div>
                    )}

                    {/* Report Groups Display */}
                    {Object.entries(reportGroups).map(([groupKey, group]) => {
                        const filteredGroupReports = getFilteredReportsForGroup(group.reports);

                        if (filteredGroupReports?.length === 0) return null;
                        if (activeGroup !== 'all' && activeGroup !== groupKey) return null;

                        return (
                            <div key={groupKey} className="mb-5">
                                <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                                    <div
                                        className="p-2 rounded me-2 d-flex align-items-center justify-content-center"
                                        style={{ backgroundColor: `${group.color}15`, color: group.color }}
                                    >
                                        {group.icon}
                                    </div>
                                    <h4 className="mb-0" style={{ fontSize: "18px", fontWeight: "600" }}>
                                        {group.name}
                                    </h4>
                                    <span className={`ms-2 badge ${skin === "dark" ? "bg-secondary" : "bg-light text-dark"}`}>
                                        {filteredGroupReports.length}
                                    </span>
                                </div>

                                <div className="row g-4">
                                    {filteredGroupReports.map((report, index) => (
                                        <div key={index} className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                            <div
                                                className={`card h-100 report-card border-0 ${skin === "dark" ? "bg-gray-800" : "bg-white"} shadow-sm`}
                                                onClick={() => handleReportClick(report)}
                                                style={{ cursor: "pointer", borderRadius: "12px" }}
                                            >
                                                <div className="card-body p-4">
                                                    <div className="d-flex align-items-start">
                                                        <div
                                                            className="report-icon me-3 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: `${report.color}15`,
                                                                color: report.color,
                                                                width: "48px",
                                                                height: "48px",
                                                                borderRadius: "12px"
                                                            }}
                                                        >
                                                            {React.cloneElement(report.icon, { size: 24 })}
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <h6 className="card-title mb-1" style={{ fontSize: "15px", fontWeight: "600" }}>
                                                                {report.name}
                                                                
                                                            </h6>
                                                            {report.description && (
                                                                <small className={`text-${skin === "dark" ? "light-50" : "muted"} d-block`}>
                                                                    {report.description}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`card-footer ${skin === "dark" ? "bg-gray-700" : "bg-light"} border-0 py-2 px-4 d-flex justify-content-between align-items-center`}>
    <small className={`text-${skin === "dark" ? "light" : "muted"} d-flex align-items-center`}>
        <BarChart className="me-1" size={12} /> View Report
    </small>
    {report.isNew && (
        <span style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            fontSize: "10px",
            fontWeight: "600",
            padding: "2px 8px",
            borderRadius: "20px",
            background: "#1cc88a20",
            color: "#0a5c3f",
            border: "1px solid #1cc88a55",
            letterSpacing: "0.6px",
            whiteSpace: "nowrap"
        }}>
            <span style={{
                width: "5px",
                height: "5px",
                borderRadius: "50%",
                background: "#1cc88a",
                display: "inline-block",
                animation: "badgePulse 1.8s ease-in-out infinite"
            }} />
            UPDATED
        </span>
    )}
</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}

                    {/* No Results */}
                    {totalFilteredReports === 0 && (
                        <div className={`text-center py-5 ${skin === "dark" ? "text-light" : "text-muted"}`}>
                            <Search size={48} className="mb-3 opacity-50" />
                            <h5>No reports found</h5>
                            <p>No reports matching "{searchTerm}" were found.</p>
                            <Button variant="outline-primary" onClick={() => setSearchTerm('')} size="sm">
                                Clear Search
                            </Button>
                        </div>
                    )}

                    {/* Transactions Section */}
                    {filteredTransactions?.length > 0 && (
                        <>
                            <hr className="my-4" />
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                                    <div className="p-2 rounded me-2 d-flex align-items-center justify-content-center" style={{ backgroundColor: "#e74a3b15", color: "#e74a3b" }}>
                                        <Layers size={18} />
                                    </div>
                                    <h4 style={{ fontSize: "18px", fontWeight: "600" }}>TRANSACTIONS</h4>
                                </div>
                                <div className="row g-4">
                                    {filteredTransactions.map((tran, index) => (
                                        <div key={index} className="col-xl-4 col-lg-4 col-md-6">
                                            <div
                                                className={`card h-100 report-card border-0 ${skin === "dark" ? "bg-gray-800" : "bg-white"} shadow-sm`}
                                                onClick={() => handleTransactionClick(tran)}
                                                style={{ cursor: "pointer", borderRadius: "12px" }}
                                            >
                                                <div className="card-body p-4">
                                                    <div className="d-flex align-items-start">
                                                        <div
                                                            className="report-icon me-3 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: `${tran.color}15`,
                                                                color: tran.color,
                                                                width: "48px",
                                                                height: "48px",
                                                                borderRadius: "12px"
                                                            }}
                                                        >
                                                            {React.cloneElement(tran.icon, { size: 24 })}
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <h6 className="card-title mb-1" style={{ fontSize: "15px", fontWeight: "600" }}>
                                                                {tran.name}
                                                            </h6>
                                                            {tran.description && (
                                                                <small className={`text-${skin === "dark" ? "light-50" : "muted"} d-block`}>
                                                                    {tran.description}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`card-footer ${skin === "dark" ? "bg-gray-700" : "bg-light"} border-0 py-2 px-4`}>
                                                    <small className={`text-${skin === "dark" ? "light" : "muted"} d-flex align-items-center`}>
                                                        <BarChart className="me-1" size={12} /> View Transactions
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* Product Addon Report Modal */}
            <Modal
                show={showProductAddonModal}
                onHide={handleCloseModal}
                centered
                size="lg"
                className={skin === "dark" ? "dark-modal" : ""}
            >
                <Modal.Header closeButton className={skin === "dark" ? "bg-gray-800 text-light border-secondary" : ""}>
                    <Modal.Title>
                        <div className="d-flex align-items-center">
                            <FileText size={24} className="me-2" style={{ color: "#9b59b6" }} />
                            Generate Product + Addon Report
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={skin === "dark" ? "bg-gray-800 text-light" : ""}>
                    <Form>
                        <Row>
                            <Col md={12} className='mb-3'>
                                <Form.Group controlId="outletSelect">
                                    <OutletSelect
                                        value={selectedOutlet}
                                        onChange={(option) => setSelectedOutlet(option)}
                                        required={true}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6} className='mb-3'>
                                <Form.Group className='d-flex flex-column' controlId="startDate">
                                    <Form.Label className="fw-semibold">Start Date <span className='text-danger'>*</span></Form.Label>
                                    <DatePicker
                                        selected={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        dateFormat="dd-MM-yyyy"
                                        className="form-control"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6} className='mb-3'>
                                <Form.Group className='d-flex flex-column' controlId="endDate">
                                    <Form.Label className="fw-semibold">End Date <span className='text-danger'>*</span></Form.Label>
                                    <DatePicker
                                        selected={endDate}
                                        onChange={handleEndDateChange}
                                        dateFormat="dd-MM-yyyy"
                                        minDate={startDate}
                                        className="form-control"
                                    />
                                    {error && <div className="text-danger small mt-1">{error}</div>}
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6} className='mb-3'>
                                <Form.Group controlId="categorySelect">
                                    <Form.Label className="fw-semibold">Category</Form.Label>
                                    <Select
                                        options={categoryOptions}
                                        value={categoryOptions.find(option => option.value === selectedCategory) || null}
                                        onChange={(selectedOption) => {
                                            const selectCategory = selectedOption?.value || '';
                                            setSelectedCategory(selectCategory);
                                            setProductId('');
                                            if (!selectCategory) {
                                                setFilteredProducts(productsList || []);
                                            } else {
                                                setFilteredProducts(
                                                    (productsList || []).filter(
                                                        (product) => product?.category?._id === selectCategory
                                                    )
                                                );
                                            }
                                        }}
                                        isClearable
                                        styles={customStyles}
                                        placeholder="Select Category"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6} className='mb-3'>
                                <Form.Group controlId="productSelect">
                                    <Form.Label className="fw-semibold">Menu Item</Form.Label>
                                    <Select
                                        options={filteredProducts?.map((product) => ({
                                            value: product._id,
                                            label: product.name,
                                        })) || []}
                                        value={productId ? { value: productId, label: filteredProducts.find((p) => p._id === productId)?.name } : null}
                                        onChange={(selectedOption) => setProductId(selectedOption ? selectedOption.value : '')}
                                        isClearable
                                        styles={customStyles}
                                        placeholder="Select Menu Item"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6} className='mb-3'>
                                <Form.Label className="fw-semibold">Addon Group</Form.Label>
                                <Select
                                    options={addons?.map((addon) => ({
                                        value: addon?._id,
                                        label: addon?.title,
                                    }))}
                                    value={addonGroup}
                                    onChange={(selectedOption) => {
                                        setAddonGroup(selectedOption || null);
                                        setSelectedAddonValue(null);
                                    }}
                                    isClearable
                                    placeholder="Select Addon Group"
                                />
                            </Col>
                            <Col md={6} className='mb-3'>
                                <Form.Label className="fw-semibold">Addon Values</Form.Label>
                                <Select
                                    components={animatedComponents}
                                    options={filteredAddonValues}
                                    value={selectedAddonValue}
                                    onChange={handleAddonValueChange}
                                    placeholder="Select Addon Value"
                                    isClearable
                                    isDisabled={!addonGroup}
                                />
                            </Col>
                        </Row>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <Button variant="outline-secondary" onClick={handleCloseModal}>
                                Cancel
                            </Button>
                            <DropdownButton
                                variant="primary"
                                title={downloading ? <Spinner size="sm" /> : 'Download Report'}
                                disabled={!selectedOutlet || !startDate || !endDate || downloading}
                                align="end"
                            >
                                <Dropdown.Item onClick={() => handleDownload(false)}>
                                    Download without costing
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleDownload(true)}>
                                    Download with costing
                                </Dropdown.Item>
                            </DropdownButton>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Online Sales Report Modal */}
            <Modal
                show={showOnlineSalesModal}
                onHide={handleCloseOnlineSalesModal}
                centered
                size="lg"
                className={skin === "dark" ? "dark-modal" : ""}
            >
                <Modal.Header closeButton className={skin === "dark" ? "bg-gray-800 text-light border-secondary" : ""}>
                    <Modal.Title>
                        <div className="d-flex align-items-center">
                            <TrendingUp size={24} className="me-2" style={{ color: "#4e73df" }} />
                            Generate Online Sales Report
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={skin === "dark" ? "bg-gray-800 text-light" : ""}>
                    <Form>
                        <Row>
                            {/* Outlet */}
                            <Col md={6} sm={12} className="mb-3">
                                <Form.Group>
                                    <OutletSelect
                                        value={onlineSalesOutlet}
                                        onChange={(option) => setOnlineSalesOutlet(option)}
                                        required={true}
                                    />
                                </Form.Group>
                            </Col>

                            {/* Platform */}
                            <Col md={6} sm={12} className="mb-3">
                                <Form.Group>
                                    <Form.Label className="fw-semibold">
                                        Platform
                                    </Form.Label>
                                    <Form.Select
                                        value={onlineSalesPlatform}
                                        onChange={(e) => setOnlineSalesPlatform(e.target.value)}
                                        className="border-secondary"
                                    >
                                        <option value="">All Platforms</option>
                                        <option value="ZOMATO">ZOMATO</option>
                                        <option value="SWIGGY">SWIGGY</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            {/* Start Date */}
                            <Col md={6} className="mb-3">
                                <Form.Group className="d-flex flex-column">
                                    <Form.Label className="fw-semibold">
                                        Start Date <span className="text-danger">*</span>
                                    </Form.Label>
                                    <DatePicker
                                        selected={onlineSalesStartDate}
                                        onChange={(date) => {
                                            setOnlineSalesStartDate(date);
                                            setOnlineSalesError('');
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Select Start Date"
                                        className="form-control"
                                        maxDate={onlineSalesEndDate || new Date()}
                                    />
                                </Form.Group>
                            </Col>

                            {/* End Date */}
                            <Col md={6} className="mb-3">
                                <Form.Group className="d-flex flex-column">
                                    <Form.Label className="fw-semibold">
                                        End Date <span className="text-danger">*</span>
                                    </Form.Label>
                                    <DatePicker
                                        selected={onlineSalesEndDate}
                                        onChange={(date) => {
                                            if (onlineSalesStartDate && date < onlineSalesStartDate) {
                                                setOnlineSalesError('End date cannot be earlier than start date');
                                            } else {
                                                setOnlineSalesError('');
                                                setOnlineSalesEndDate(date);
                                            }
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Select End Date"
                                        className="form-control"
                                        minDate={onlineSalesStartDate}
                                        maxDate={new Date()}
                                    />
                                    {onlineSalesError && (
                                        <div className="text-danger small mt-1">{onlineSalesError}</div>
                                    )}
                                </Form.Group>
                            </Col>

                            {/* Category */}
                            <Col md={12} className="mb-3">
                                <Form.Group>
                                    <Form.Label className="fw-semibold">Category</Form.Label>
                                    <Select
                                        options={categoryOptions}
                                        value={categoryOptions.find(opt => opt.value === onlineSalesCategory) || null}
                                        onChange={(selectedOption) => setOnlineSalesCategory(selectedOption?.value || '')}
                                        isClearable
                                        styles={customStyles}
                                        placeholder="Select Category (Optional)"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <Button variant="outline-secondary" onClick={handleCloseOnlineSalesModal}>
                                Cancel
                            </Button>
                            <DropdownButton
                                variant="primary"
                                title={onlineSalesDownloading ? <Spinner size="sm" animation="border" /> : 'Download Report'}
                                disabled={!onlineSalesOutlet || !onlineSalesStartDate || !onlineSalesEndDate || onlineSalesDownloading || !!onlineSalesError}
                                align="end"
                            >
                                <Dropdown.Item onClick={() => handleOnlineSalesDownload(false)}>
                                    <FileEarmarkSpreadsheet className="me-2" />
                                    Download without costing
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => handleOnlineSalesDownload(true)}>
                                    <FileEarmarkSpreadsheet className="me-2" />
                                    Download with costing
                                </Dropdown.Item>
                            </DropdownButton>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            <style>{`
                @keyframes badgePulse {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.6; }
                }
                .report-card {
                    transition: transform 0.2s, box-shadow 0.2s;
                }
                .report-card:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important;
                }
                .bg-gray-800 {
                    background-color: #1e1e2d !important;
                }
                .bg-gray-700 {
                    background-color: #2a2a3a !important;
                }
                .text-light-50 {
                    color: rgba(255, 255, 255, 0.5) !important;
                }
                .dark-modal .modal-content {
                    background-color: #1e1e2d;
                    color: #fff;
                }
                .dark-modal .modal-header,
                .dark-modal .modal-footer {
                    border-color: #2a2a3a;
                }
                .dark-modal .form-control,
                .dark-modal .form-select {
                    background-color: #2a2a3a;
                    border-color: #3a3a4a;
                    color: #fff;
                }
                .dark-modal .form-control:focus {
                    background-color: #2a2a3a;
                    border-color: #4e73df;
                    color: #fff;
                }
                .dark-modal .btn-close {
                    filter: invert(1);
                }
            `}</style>
        </React.Fragment>
    );
};

export default AllReports;